import functions from "./functions";

function init(){

    if (functions.checkPage('cart-page')) {
        $('body').on("click", '[data-cart-clear]', clearCart);
    }
}


function clearCart(){
    window.location.assign('?clear-cart');
}

export default {init};


// WEBPACK FOOTER //
// ./src/scripts/cart-page.js